// Add here your string utils
export const byteSizeFormatter = (bytes: number | null): string => {
    if (!bytes || bytes === 0) return "0Bytes";

    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / k ** i).toFixed(0))}${sizes[i]}`;
};

export const isNotEmpty = (value: string | null | undefined): boolean => {
    return value && (value ?? false) ? value.trim() !== "" : false;
};

export const isEmpty = (value: string | null | undefined): boolean => {
    return !isNotEmpty(value);
};

export const isNumeric = (value: string | number | null | undefined): boolean => {
    return (
        value !== undefined &&
        value != null &&
        (typeof value !== "string" || isNotEmpty(value)) &&
        !isNaN(Number(value))
    );
};

export const isNumericAndNot0 = (value: string | number | null | undefined): boolean => {
    return isNumeric(value) && Number(value) !== 0;
};

export const replaceUrlParams = (path: string, params: object) => {
    let newPath = path;
    Object.entries(params).forEach((entry) => {
        const [key, value] = entry;
        newPath = newPath.replace(`:${key}`, value);
    });
    return newPath;
};

export const stripHTMLTags = (text: string): string => {
    const regexHTMLTags = /(<([^>]+)>)/gi;
    const textWithoutHTMLTags = (text || "").replace(regexHTMLTags, "");
    return textWithoutHTMLTags;
};
